import { render, staticRenderFns } from "./ReporteDetalles.vue?vue&type=template&id=80b03e4e&"
import script from "./ReporteDetalles.vue?vue&type=script&lang=js&"
export * from "./ReporteDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports